import { type IServiceDec } from '@App/types/servicesTypes'

const onAddDeepness = (data: IServiceDec[], deepness: number = 1): IServiceDec[] => {
    const result = []
    for (let i = 0; i <= data.length - 1; i++) {
        const item = { deepness, ...data[i], childCategories: onAddDeepness(data[i].childCategories, deepness + 1) }
        result.push(item)
    }
    return result
}

const onAddSectionPath = (list: IServiceDec[], parentPath: string[] = []) => {
    const result = []
    for (let i = 0; i <= list.length - 1; i++) {
        let current = list[i]
        current = {
            ...current,
            childCategories: onAddSectionPath(current.childCategories, [...parentPath, current.name]),
            path: [...parentPath, current.name],
            childServices: current.childServices.map((el) => ({
                ...el,
                path: [...parentPath, current.name, el.name],
                parentId: current.id
            }))
        }
        result.push(current)
    }
    return result
}

export const onHandleServicesListAdditionsProps = (data: IServiceDec[]) => onAddDeepness(onAddSectionPath(data))
